import Text from '@eversports/klimt-primitives/legacy/Text'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'
import { isToday, isTomorrow } from 'date-fns'

import { formatDate } from '../../helpers/format-date'
import { Localized } from '../../localization/react'

interface Props {
  date: string
}

// Color contrasts weren't working - now using colors from the nextjs design system palette
const MatchDate = ({ date }: Props) => {
  const dateObj = new Date(date)
  const { language } = useSettingsContext()

  if (isToday(dateObj)) {
    return (
      <Text
        variant="small"
        sx={{ fontWeight: 'bold', color: 'red', backgroundColor: '#f9ebeb', paddingX: 2, paddingY: 0.5 }}
      >
        <Localized id="today" />
      </Text>
    )
  }

  if (isTomorrow(dateObj)) {
    return (
      <Text
        variant="small"
        sx={{ fontWeight: 'bold', color: 'tertiarySelected', backgroundColor: '#fdf2e7', paddingX: 2, paddingY: 0.5 }}
      >
        <Localized id="tomorrow" />
      </Text>
    )
  }

  return <Text variant="small">{formatDate(language, date)}</Text>
}

export default MatchDate
